import React from 'react';
import { Empty } from 'antd';
import { imagePath } from '@common/services/images-service';
import { Colors } from 'works/legacy/lib/style-helper';

export const EmptyContent = ({
  text,
  header,
  ...props
}: {
  text?: React.ReactNode;
  header?: string;
  image?: string;
  imagePath?: string;
  height?: number;
}) => {
  const image = props.image || imagePath(props.imagePath);
  const height = props.height || 200;

  return (
    <Empty
      image={image}
      imageStyle={{
        height,
        maxWidth: '100%',
      }}
      description={null}
    >
      <span className="empty-header">{header}</span>
      <span className="empty-content">{text}</span>
      <style jsx>{`
        .empty-header {
          display: block;
          padding: 24px 0 16px;
          font-size: 20px;
          font-weight: 700;
        }
        .empty-content {
          display: block;
          color: ${Colors.midnightLighter};
          font-size: 20px;
          font-weight: 300;
        }
      `}</style>
    </Empty>
  );
};
